import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  taskStatuses: null,
  taskStatusesError: null,
  taskStatusesLoading: false,
  taskStatusChangeError: null,
  taskStatusChangeLoading: false,
  taskPipelinesControlConfig: null,
  taskPipelinesControlConfigError: null,
  taskPipelinesControlConfigLoading: false,
};

const getTaskStatusesStart = (state, action) => {
  return updateObject(state, {
    taskStatusesError: null,
    taskStatusesLoading: true,
  });
};

const getTaskStatusesSuccess = (state, action) => {
  return updateObject(state, {
    taskStatuses: action.taskStatuses,
    taskStatusesError: null,
    taskStatusesLoading: false,
  });
};

const getTaskStatusesFail = (state, action) => {
  return updateObject(state, {
    taskStatuses: null,
    taskStatusesError: action.error,
    taskStatusesLoading: false,
  });
};

const changeTaskStatusStart = (state, action) => {
  return updateObject(state, {
    taskStatusChangeError: null,
    taskStatusChangeLoading: true,
  });
};

const changeTaskStatusSuccess = (state, action) => {
  return updateObject(state, {
    taskStatusChangeError: null,
    taskStatusChangeLoading: false,
  });
};

const changeTaskStatusFail = (state, action) => {
  return updateObject(state, {
    taskStatusChangeError: action.error,
    taskStatusChangeLoading: false,
  });
};

const getTaskPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    taskPipelinesControlConfigError: null,
    taskPipelinesControlConfigLoading: true,
  });
};

const getTaskPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    taskPipelinesControlConfig: action.taskPipelinesControlConfig,
    taskPipelinesControlConfigError: null,
    taskPipelinesControlConfigLoading: false,
  });
};

const getTaskPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    taskPipelinesControlConfig: null,
    taskPipelinesControlConfigError: action.error,
    taskPipelinesControlConfigLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TASK_STATUSES_START:
      return getTaskStatusesStart(state, action);
    case actionTypes.GET_TASK_STATUSES_SUCCESS:
      return getTaskStatusesSuccess(state, action);
    case actionTypes.GET_TASK_STATUSES_FAIL:
      return getTaskStatusesFail(state, action);

    case actionTypes.CHANGE_TASK_STATUS_START:
      return changeTaskStatusStart(state, action);
    case actionTypes.CHANGE_TASK_STATUS_SUCCESS:
      return changeTaskStatusSuccess(state, action);
    case actionTypes.CHANGE_TASK_STATUS_FAIL:
      return changeTaskStatusFail(state, action);

    case actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_START:
      return getTaskPipelinesControlConfigStart(state, action);
    case actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return getTaskPipelinesControlConfigSuccess(state, action);
    case actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_FAIL:
      return getTaskPipelinesControlConfigFail(state, action);

    default:
      return state;
  }
};

export default reducer;
